import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DataService } from "../../data.service";

@Component({
    selector: 'app-admin-consolidations',
    templateUrl: './admin-consolidations.component.html',
    styleUrls: ['./admin-consolidations.component.css'],
    standalone: false
})
export class AdminConsolidationsComponent implements OnInit {

    constructor(private dataService: DataService, private confirmationService: ConfirmationService) {
    }

    ngOnInit(): void {
        
    }
}